import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify' // path to vuetify export
import Default from './layouts/google-keep.vue'
import Minimalist from './layouts/minimalist.vue'
import VueNativeNotification from 'vue-native-notification'
import firebase from '@firebase/app'
import '@firebase/firestore'
import '@firebase/auth'
import * as firebaseui from 'firebaseui'
import { firestorePlugin } from 'vuefire'
import VueAnalytics from 'vue-analytics'
import Vue2Storage from 'vue2-storage'
import VueRouter from 'vue-router'
import VCalendar from 'v-calendar';

Vue.config.productionTip = false

Vue.use(VueNativeNotification, {
  // Automatic permission request before
  // showing notification (default: true)
  requestOnNotify: true
})

Vue.use(firestorePlugin)

const app = firebase.initializeApp({
  apiKey: 'AIzaSyASPB9hRFKddIP8WxfbJdkLyU6eAUDpzaE',
  authDomain: 'deepworkhours.com',
  databaseURL: 'https://pomodoro-80211.firebaseio.com',
  projectId: 'pomodoro-80211',
  storageBucket: 'pomodoro-80211.appspot.com',
  messagingSenderId: '240852760256'
})

const firestore = app.firestore()

export const db = firestore.collection(process.env.NODE_ENV).doc('v1')

app.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
export const ui = new firebaseui.auth.AuthUI(app.auth());
export const auth = app.auth();

Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GOOGLE_ANALYTICS
})

Vue.use(Vue2Storage, {
  prefix: 'app_',
  driver: 'local',
  ttl: 60 * 60 * 24 * 1000
})

Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    {
      path: '/track',
      component: require("./scenes/Scoreboard").default,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      component: require("./scenes/Login").default,
      meta: {
        layout: 'minimalist'
      }
    },
    {
      path: '/settings',
      component: require("./scenes/Settings").default,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/focus',
      component: require("./scenes/Focus").default,
      meta: {
        requiresAuth: true
      }
    },
    // {
    //   path: '/',
    //   redirect: '/login'
    // },
    {
      path: '/',
      component: require("./scenes/Landing").default,
      meta: {
        layout: 'minimalist'
      }
    },
    {
      path: '*',
      redirect: '/login'
    },
  ]
});

router.beforeEach((to, from, next) => {
  const currentUser = auth.currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !currentUser) next('/');
  else if (!requiresAuth && currentUser) next('/focus');
  else next();
});

// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
  componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
});

Vue.component("default-layout", Default);
Vue.component("minimalist-layout", Minimalist);

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app');
